module.exports = __webpack_public_path__ + "img/07-04_Taking Initiative.3bd505af.svg";